export default "__VITE_ASSET__ChOFSr41__"